import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../components/Admin/Sidebar";
import * as Icon from "react-bootstrap-icons";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
// import { getOrder } from './Orders';
import axios from "axios";
import { getProducts } from "./Products";
import { getAccounts } from "./Allaccounts";

const Dashboard = () => {
  const auth = useContext(UserContext);

  const [toggleValue, setToggleValue] = useState(false);
  const [orderCount, setOrderCount] = useState(0);
  const [productCount, setProductCount] = useState(0);
  const [accountsCount, setAccountsCount] = useState(0);
  const [distributorCount, setDistributorCount] = useState(0);
  const [sold, setSold] = useState("");
  const [commissionTotalAmount, setcommissionTotalAmount] = useState(0);
  const [withDrawalAmount, setwithDrawalAmount] = useState(0);
  const [referedUser, setreferedUser] = useState(0);
  const [referedUserId, setreferedUserId] = useState(0);
  const [treeData, setTreeData] = useState(null);

  // Authentication
  const authtoken = localStorage.getItem("token");
  const token = `Bearer ${authtoken}`;

  useEffect(() => {
    getAllOrderOfAdmin();
  }, []);
  useEffect(() => {
    getOrderOfUser();
  }, []);
  useEffect(() => {
    getParentData();
    fetchTotalCommissionData();
  }, []);

  const getOrderOfUser = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}order/getallorders`,
        {
          headers: {
            Authorization: token,
            // 'Authorization': `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getAllOrderOfAdmin = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}order/all`,
        {
          headers: {
            Authorization: token,
            // 'Authorization': `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchTotalCommissionData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}userinfo/alluserdata`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const fetchedData = response.data;

      return fetchedData;
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const getParentData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}userinfo/tree`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const fetchedData = response.data;
      const tree = transformDataToTree(fetchedData);
      tree.totalChildren = countChildren(tree);

      setTreeData(tree);
    } catch (error) {
      console.error("Error: " + error);
    }
  };
  // accessed tree
  const transformDataToTree = (data) => {
    const children = [];
    if (data.left_child) {
      children.push(transformDataToTree(data.left_child));
    }
    if (data.right_child) {
      children.push(transformDataToTree(data.right_child));
    }
    return {
      name: data.name,
      refCode: data.referral_code || "N/A",
      profilePhoto:
        data.profilePhoto ||
        "https://pronedvizhimost.ru/static/custom/img/default/user.png",
      children: children.length > 0 ? children : null,
      collapsed: false,
    };
  };
  ///calculating the child node for each node
  const countChildren = (node) => {
    if (!node || !Array.isArray(node.children) || node.children.length === 0) {
      return 0;
    }

    node.totalChildren =
      node.children.length +
      node.children.reduce((acc, child) => {
        return acc + countChildren(child);
      }, 0);

    return node.totalChildren;
  };
  //all seller count
  const getAllSellerOrder = async (token) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}order/getOrdersBySeller`,
        {
          headers: {
            // Authorization: token,
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data.orders;
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getData = async (token) => {
    const orderadmin = await getAllOrderOfAdmin(token);
    const orderuser = await getOrderOfUser(token);
    const orderseller = await getAllSellerOrder(token);
    const product = await getProducts(token);
    const accounts = await getAccounts(token);
    // setOrderCount(order?.orders?.length)
    const totalCommissionAmonut = await fetchTotalCommissionData(token);
    setcommissionTotalAmount(
      totalCommissionAmonut.parentUser.walletBalance
    );

    const totalWithdrawalAmount = totalCommissionAmonut.referredUsers
      .map((user) => Number(user.commissionBalance)) // Extract and convert to number
      .reduce((total, balance) => total + balance, 0); // Sum up the balances
    setwithDrawalAmount(totalWithdrawalAmount); // Set the total amount
    setreferedUser(totalCommissionAmonut?.referredUsers?.length);
    setreferedUserId(totalCommissionAmonut.parentUser.referral_code);

    if (auth?.user?.userType == "user") {
      setOrderCount(orderuser?.length);
    } else if (auth?.user?.userType == "distributor") {
      setOrderCount(orderseller?.length);
    } else {
      setOrderCount(orderadmin?.allOrders?.length);
    }

    setProductCount(product?.products?.myProducts?.length);
    const users = accounts.accounts?.filter(
      (account) => account.userType === "user"
    );

    setAccountsCount(users?.length);

    const distributor = accounts.accounts?.filter(
      (account) => account.userType === "distributor"
    );
    setDistributorCount(distributor?.length);

    let allSold = [];

    product?.products?.myProducts?.map((item) => {
      if (parseInt(item.orderQty) > 0) {
        allSold.push(parseInt(item.orderQty));
      }

      return 0;
    });

    const sum = allSold.reduce((acc, curr) => acc + curr, 0);
    setSold(sum);
  };

  useEffect(() => {
    getData(token);
  }, [token]);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);
  const UserType = localStorage.getItem("userType");

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2 p-0">
          <Sidebar
            toggleSidebar={toggleValue}
            setToggleValue={setToggleValue}
          />
        </div>
        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            className="my-5 sidebar-open"
            color="black"
            size={30}
          ></Icon.ArrowRight>
          <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
            <div className="col-12">
              <div className="row mb-4">
                <div className="col-lg-3">
                  <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                    <div className="col-5 d-flex justify-content-center align-items-center">
                      <Icon.PersonCheckFill size={50} />
                    </div>
                    <div className="col-7 text-end" style={{ height: 70 }}>
                      <h5 className="text-muted">USERID</h5>
                      <h4>{referedUserId ? referedUserId : "00"}</h4>
                    </div>
                    <section
                      className="border-top border-1 mt-4 p-2"
                      style={{ height: 40 }}
                    >
                      {/* <Link to='/contact' className='nav-link'>Contact <Icon.ArrowRight className='ms-2' /></Link> */}
                    </section>
                  </div>
                </div>

                {auth?.user?.userType === "admin" && (
                  <div className="col-lg-3">
                    <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                      <div className="col-5 d-flex justify-content-center align-items-center">
                        <Icon.PersonCircle size={50} />
                      </div>
                      <div className="col-7 text-end" style={{ height: 70 }}>
                        <h5 className="text-muted">Member</h5>
                        <h4>
                          {accountsCount !== "" ? (
                            accountsCount < 10 ? (
                              "0" + accountsCount
                            ) : (
                              accountsCount
                            )
                          ) : (
                            <div
                              className="spinner-grow spinner-grow-sm"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          )}
                        </h4>
                      </div>
                      <section
                        className="border-top border-1 mt-4 p-2"
                        style={{ height: 40 }}
                      >
                        <Link to="/users" className="nav-link">
                          view all
                          <Icon.ArrowRight className="ms-2" />
                        </Link>
                      </section>
                    </div>
                    {/* Card */}
                  </div>
                )}

                <div className="col-lg-3">
                  {/* Card */}
                  <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                    <div className="col-5 d-flex justify-content-center align-items-center">
                      <Icon.Cart4 size={50} />
                    </div>
                    <div className="col-7 text-end" style={{ height: 70 }}>
                      <h5 className="text-muted">Orders</h5>
                      <h4>
                        {orderCount !== "" ? (
                          orderCount < 10 ? (
                            "0" + orderCount
                          ) : (
                            orderCount
                          )
                        ) : (
                          <div
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        )}
                      </h4>
                    </div>

                    {auth?.user?.userType == "user" ? (
                      <section
                        className="border-top border-1 mt-4 p-2"
                        style={{ height: 40 }}
                      >
                        <Link to="/orders" className="nav-link">
                          view all
                          <Icon.ArrowRight className="ms-2" />
                        </Link>
                      </section>
                    ) : (
                      <section
                        className="border-top border-1 mt-4 p-2"
                        style={{ height: 40 }}
                      >
                        <Link to="/allorders" className="nav-link">
                          view all
                          <Icon.ArrowRight className="ms-2" />
                        </Link>
                      </section>
                    )}
                  </div>
                  {/* Card */}
                </div>

                {/* ----------------------------------Products-------------------------------- */}
                {UserType === "admin" || UserType === "distributor" ? (
                  <div className="col-lg-3">
                    <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                      <div className="col-5 d-flex justify-content-center align-items-center">
                        <Icon.Bag size={50} />
                      </div>
                      <div className="col-7 text-end" style={{ height: 70 }}>
                        <h5 className="text-muted">Products</h5>
                        <h4>
                          {productCount !== "" ? (
                            productCount < 10 ? (
                              "0" + productCount
                            ) : (
                              productCount
                            )
                          ) : (
                            <div
                              className="spinner-grow spinner-grow-sm"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          )}
                        </h4>
                      </div>
                      <section
                        className="border-top border-1 mt-4 p-2"
                        style={{ height: 40 }}
                      >
                        <Link to="/products" className="nav-link">
                          view all
                          <Icon.ArrowRight className="ms-2" />
                        </Link>
                      </section>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {/* ----------------------------------incentive-------------------------------- */}
                {UserType === "admin" || UserType === "user" || UserType === "distributor" ? (
                  <div className="col-lg-3">
                    <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                      <div className="col-5 d-flex justify-content-center align-items-center">
                        <Icon.Paypal size={50} />
                      </div>
                      <div className="col-7 text-end" style={{ height: 70 }}>
                        <h5 className="text-muted">Incentive/</h5>
                        <h5 className="text-muted">Balance</h5>
                        <h4>
                          <Icon.CurrencyRupee />{commissionTotalAmount ? commissionTotalAmount : "00"}
                        </h4>
                      </div>
                      <section
                        className="border-top border-1 mt-4 p-2"
                        style={{ height: 40 }}
                      >
                        <Link to="/commission" className="nav-link">
                          view all
                          <Icon.ArrowRight className="ms-2" />
                        </Link>
                      </section>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {/* ----------------------------------Business Volume-------------------------------- */}
                <div className="col-lg-3">
                  <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                    <div className="col-5 d-flex justify-content-center align-items-center">
                      <Icon.BarChart size={50} />
                    </div>
                    <div className="col-7 text-end" style={{ height: 70 }}>
                      <h5 className="text-muted">Business</h5>
                      <h5 className="text-muted">Volume (BV)</h5>
                      <h4 className="text-success fw-bold">
                        {auth?.user?.businessVolume || "0.00"}
                      </h4>
                    </div>
                    <section
                      className="border-top border-1 mt-4 p-2"
                      style={{ height: 40 }}
                    >
                      <Link to="/userprofile" className="nav-link">
                        view profile
                        <Icon.ArrowRight className="ms-2" />
                      </Link>
                    </section>
                  </div>
                </div>
                {/* ------------------------ pending balance------------------------------------ */}

                <div className="col-lg-3">
                  <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                    <div className="col-5 d-flex justify-content-center align-items-center">
                      <Icon.Clock size={50} />
                    </div>
                    <div className="col-7 text-end" style={{ height: 70 }}>
                      <h5 className="text-muted">Pending Balance</h5>
                      {/* <h4>
                          {productCount !== "" ? (
                            productCount < 10 ? (
                              "0" + productCount
                            ) : (
                              productCount
                            )
                          ) : (
                            <div
                              className="spinner-grow spinner-grow-sm"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          )}
                        </h4> */}
                    </div>
                    <section
                      className="border-top border-1 mt-4 p-2"
                      style={{ height: 40 }}
                    >
                      <Link to="/pending-balance" className="nav-link">
                        view all
                        <Icon.ArrowRight className="ms-2" />
                      </Link>
                    </section>
                  </div>
                </div>

                {/* ----------------------------withdrawal-------------------------------------- */}
                <div className="col-lg-3">
                  <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                    <div className="col-5 d-flex justify-content-center align-items-center">
                      <Icon.Wallet size={50} />
                    </div>
                    <div className="col-7 text-end" style={{ height: 70 }}>
                      <h5 className="text-muted">WithDrawal</h5>
                      {/* <h4>{withDrawalAmount ? withDrawalAmount : "00"}</h4> */}
                    </div>
                    <section
                      className="border-top border-1 mt-4 p-2"
                      style={{ height: 40 }}
                    >
                      <Link to="/withdrawal" className="nav-link">
                        view all
                        <Icon.ArrowRight className="ms-2" />
                      </Link>
                    </section>
                  </div>
                </div>

                {/* -----------------------------Refered users------------------------------------- */}
                <div className="col-lg-3">
                  <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                    <div className="col-5 d-flex justify-content-center align-items-center">
                      <Icon.PersonCircle size={50} />
                    </div>
                    <div className="col-7 text-end" style={{ height: 70 }}>
                      <h5 className="text-muted">Refered Users</h5>
                      <h4>
                        {treeData
                          ? countChildren(treeData) < 10
                            ? "0" + countChildren(treeData)
                            : countChildren(treeData)
                          : "00"}
                      </h4>
                    </div>
                    <section
                      className="border-top border-1 mt-4 p-2"
                      style={{ height: 40 }}
                    >
                      <Link to="/commission" className="nav-link">
                        view all
                        <Icon.ArrowRight className="ms-2" />
                      </Link>
                    </section>
                  </div>
                </div>

                {/* -----------------------------Distribute page------------------------------------- */}

                {UserType === "admin" ? (
                  <div className="col-lg-3">
                    <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                      <div className="col-5 d-flex justify-content-center align-items-center">
                        <Icon.PeopleFill size={50} />
                      </div>
                      <div className="col-7 text-end" style={{ height: 70 }}>
                        <h5 className="text-muted">Distributor</h5>
                        <h4>
                          {distributorCount !== "" ? (
                            distributorCount < 10 ? (
                              "0" + distributorCount
                            ) : (
                              distributorCount
                            )
                          ) : (
                            <div
                              className="spinner-grow spinner-grow-sm"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          )}
                        </h4>
                      </div>
                      <section
                        className="border-top border-1 mt-4 p-2"
                        style={{ height: 40 }}
                      >
                        <Link to="/allsellerorderlist" className="nav-link">
                          view all
                          <Icon.ArrowRight className="ms-2" />
                        </Link>
                      </section>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {/* ---------------------------------support--------------------------------- */}
                <div className="col-lg-3">
                  <div className="row bg-light border border-1 p-3 m-1 rounded mb-3">
                    <div className="col-5 d-flex justify-content-center align-items-center">
                      <Icon.PhoneVibrate size={50} />
                    </div>
                    <div className="col-7 text-end" style={{ height: 70 }}>
                      <h5 className="text-muted">Support</h5>
                      <h4></h4>
                    </div>
                    <section
                      className="border-top border-1 mt-4 p-2"
                      style={{ height: 40 }}
                    >
                      <Link to="/contact" className="nav-link">
                        Contact <Icon.ArrowRight className="ms-2" />
                      </Link>
                    </section>
                  </div>
                </div>

                {/* -------------------------sold section part---------------------------------------- */}
                {/* <div className="col-lg-3">
 
                  <div className='row bg-light border border-1 p-4 m-1 rounded'>
                    <div className='col-5 d-flex justify-content-center align-items-center'>
                      <Icon.GraphUp size={50} />
                    </div>
                    <div className="col-7 text-end">
                      <h5 className='text-muted'>Sold</h5>
                      <h4> */}
                {/* {
                          sold !== ''
                            ?
                            sold < 10 ? '0' + sold : sold
                            :
                            <div className="spinner-grow spinner-grow-sm" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                        } */}

                {/* {
                          totalsellbyseller === ''
                            ? "00"
                           : totalsellbyseller ? totalsellbyseller.length 
                           :
                            <div className="spinner-grow spinner-grow-sm" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                        }

                      </h4>
                    </div>
                    <section className='border-top border-1 mt-4 p-3'>
                      <Link to='/dashboard/soldproducts' className='nav-link'>view details<Icon.ArrowRight className='ms-2' /></Link>
                    </section>
                  </div>
                </div> */}
                {/* -------------------------------------------------------------------- */}

                {/* Card */}
                {/* Inventory */}
                {/* {
                  auth?.user?.userType === 'admin' &&
                  <div className="col-lg-3">
                    <div className='row bg-light border border-1 p-4 m-1 rounded'>
                      <div className='col-5 d-flex justify-content-center align-items-center'>
                      <Icon.Table size={50} />
                      </div>
                      <div className="col-7 text-end">
                        <h5 className='text-muted'>Inventory</h5>
                        <h4>
                          {
                            accountsCount !== ''
                              ?
                              accountsCount < 10 ? '0' + accountsCount : accountsCount
                              :
                              <div className="spinner-grow spinner-grow-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                          }
                        </h4>
                      </div>
                      <section className='border-top border-1 mt-4 p-3'>
                        <Link to='/inventory' className='nav-link'>view all<Icon.ArrowRight className='ms-2' /></Link>
                      </section>
                    </div>
                  </div>
                } */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
